import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useFieldErrorStyles = makeStyles({
  root: {
    marginTop: designTokens.spacing[1],
    marginBottom: designTokens.spacing[1],
    color: designTokens.semantic.error,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.normal,
    lineHeight: "16px",
    paddingLeft: `calc(12px + ${designTokens.spacing[1]})`,
  },
  icon: {
    display: "inline-block",
    fontSize: designTokens.fontSize.xs,
    marginLeft: `calc(-${designTokens.fontSize.xs} - ${designTokens.spacing[1]})`,
    marginRight: designTokens.spacing[1],
    lineHeight: "0",
    verticalAlign: "-1px",
    color: designTokens.semantic.error,
  },
});
